import Layout from "../pages/Layout";
import ContactComp from "../components/ContactComp";
//import TopBar from "../components/TopBar";
import { Helmet } from "react-helmet";

const Contact = () => {
  

  return (
    <div>
      <Helmet>
        <title>Contact Us - Factbazaar</title>
        <meta name="description" content="Get in touch with Factbazaar for inquiries, feedback, or support. We are here to help!" />
  <meta name="keywords" content="Contact Factbazaar, Support, Feedback, News Inquiry, Customer Service" />
  <meta name="author" content="Factbazaar Team" />
      </Helmet>
      <Layout>
      <ContactComp/>  
      </Layout>
    </div>
  );
};

export default Contact;
